import { useState } from "react";
import { motion, useMotionValueEvent, useTransform } from "framer-motion";

export default function DepthHUD({ scrollYProgress }) {
  const depth = useTransform(scrollYProgress, [0, 1], [0, 3000]);
  const depthText = useTransform(depth, (v) =>
    Math.round(v).toLocaleString("en-US")
  );
  const zone = useTransform(depth, (v) =>
    v < 200
      ? "Sunlight Zone"
      : v < 1000
        ? "Twilight Zone"
        : v < 2950
          ? "Midnight Zone"
          : "The Vents"
  );
  const [deep, setDeep] = useState(false);
  useMotionValueEvent(scrollYProgress, "change", (v) => setDeep(v > 0.1));

  return (
    <aside
      data-testid="depth-hud"
      className={`fixed right-4 top-1/2 z-30 flex -translate-y-1/2 flex-col items-center gap-5 transition-colors duration-700 md:right-8 ${
        deep ? "text-[#F8FAFC]" : "text-[#02252e]"
      }`}
    >
      <motion.span
        style={{ writingMode: "vertical-rl" }}
        className="font-mono text-[9px] uppercase tracking-[0.35em] opacity-70 md:text-[10px]"
        data-testid="depth-zone-label"
      >
        {zone}
      </motion.span>
      <div className="relative h-32 w-px overflow-hidden md:h-44">
        <div className="absolute inset-0 bg-current opacity-25" />
        <motion.div
          className="absolute inset-x-0 top-0 h-full origin-top bg-current"
          style={{ scaleY: scrollYProgress }}
        />
      </div>
      <div className="flex flex-col items-center">
        <motion.span
          className="font-mono text-xl font-medium tabular-nums md:text-2xl"
          data-testid="depth-value"
        >
          {depthText}
        </motion.span>
        <span className="mt-1 font-mono text-[9px] tracking-[0.3em] opacity-70">
          M
        </span>
        <span className="mt-3 font-mono text-[9px] tracking-[0.2em] opacity-40">
          3,000
        </span>
      </div>
    </aside>
  );
}
